import React, {useState} from "react";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import localforage from "localforage";
import {saveAs} from 'file-saver';
import cloneDeep from "lodash.clonedeep";
import forEach from "lodash.foreach";
import uniq from "lodash.uniq"; 

const configSingletonToken = Symbol();
export class Config
{
    #isInited = false;

    constructor (token)  
    {        
        if (configSingletonToken !== token)
        {
            throw new Error('This class cannot instantiate directly')
        }
    }     
    static get instance () 
    {
        if (!this[configSingletonToken])
        {
            this[configSingletonToken] = new Config(configSingletonToken);
        }

        return this[configSingletonToken];
    }
	async init (url = 'config.json', data = {})
	{
        if (!this.#isInited)
        {
            this._url = url;
            this._data = Object.assign({}, data || {});

            const res = await fetch(this._url);
            this._data = await res.json();

            this.#isInited = true;
        }

        return this;
	}
	get (code, defVal = null)
	{
        let value = null;

        //console.log('in get, data', this._data);
        
		if (this.isset(code))
		{
			value = this._data[code];
		} 
		else if (null !== defVal)
		{
			value = defVal;
		}
		return value;
	}	
	values ()
	{
		return this._data;
	}
	isset (code)
	{
		return code in this._data;
	}
	extend (config)
	{
        Object.assign(this._data, config.values() || {});
	}
}
const dictSingletonToken = Symbol();
export class Dictionary
{
    #isInited = false;

    constructor (token) 
    {        
        if (dictSingletonToken !== token)
        {
            throw new Error('This class cannot instantiate directly')
        }
    }    
    static get instance () 
    {
        if (!this[dictSingletonToken])
        {
            this[dictSingletonToken] = new Dictionary(dictSingletonToken);
        }

        return this[dictSingletonToken];
    }
	async init ()
	{
        if (!this.#isInited)
        {
            this._data = await Server.instance.query('get_dicts');

            this.#isInited = true;
        }

        return this;
	}
	get (name)
	{
        let dict = {};
        
		if (this.isset(name))
		{
			dict = this._data[name];
		}
		return dict;
	}
	isset (name)
	{
		return name in this._data;
	}
}
const serverSingletonToken = Symbol();
export class Server
{   
    #url = '';

    constructor (token) 
    {        
        if (serverSingletonToken !== token)
        {
            throw new Error('This class cannot instantiate directly')
        }

        //console.log('...', Config.instance.get('server_url', '123)))'));

        this.#url = Config.instance.get('server_url', '/server.php');
    }    
    static get instance () 
    {
        if (!this[serverSingletonToken])
        {
            this[serverSingletonToken] = new Server(serverSingletonToken);
        }

        return this[serverSingletonToken];
    }
    async load (type = '', params = {})
    {
        params.type = type;

        try 
        {
            const response = await fetch(this.#url,
                {
                    method: 'POST',
                    body: JSON.stringify({
                        cmd: 'load',
                        params
                    }),
                    cache: 'no-cache'
                }),            
                result = await response.blob();

            let filename;
            switch (type)
            {
                case 'pricelist':

                    filename = 'Счёт';
                    break;

                case 'specification':

                    filename = 'Спецификация';
                    break;

                default:

                    filename = 'Файл';
                    break;
            }
            filename+='.xlsx';

            saveAs(result, filename);
        }
        catch (error)
        {
            throw new Error4Admin(error);
        } 
    }
    async query (cmd, params = {})    
    {
        let result;
        try 
        {
            const response = await fetch(this.#url, 
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(
                    {
                        cmd,
                        params
                    }),
                    cache: 'no-cache'
                });
            
            result = await response.json();
        }
        catch (error)
        {
            throw new Error4Admin(error);
        }        

        if (false !== result['error_code'])
        {
            const errorCode = parseInt(result['error_code']);

            if (isNaN(errorCode))
            {
                errorCode = 0;
            }

            if (errorCode >= 100)
            {
                throw new Error4User(result['result']);
            }
            else
            {
                throw new Error4Admin(result['result']);
            }
        }

        return result['result'];
    }
}
const storeSingletonToken = Symbol();
export class Store
{
	// https://localforage.github.io/localForage/
    // localforage.setDriver(localforage.LOCALSTORAGE);
    
    constructor (token) 
    {        
        if (storeSingletonToken !== token)
        {
            throw new Error('This class cannot instantiate directly')
        }
    }    
    static get instance () 
    {
        if (!this[storeSingletonToken])
        {
            this[storeSingletonToken] = new Store(storeSingletonToken);
        }

        return this[storeSingletonToken];
    }

	async get (subj, defVal = null)
	{
		return localforage.getItem(subj)
                    .then(function (value)
                    {
                        return !value && null !== defVal ? defVal : value;
                    });
	}
	async set (subj, val)
	{
		return localforage.setItem(subj, val);
	}
	async del (subj)
	{
		return localforage.removeItem(subj);
	}
	async clear ()
	{
		return localforage.clear();
	}
}
const projectSingletonToken = Symbol();
export class Project
{
    _data = {};
    _fragments = [];
    _curFragmentID = null;

    constructor (token) 
    {        
        if (projectSingletonToken !== token)
        {
            throw new Error('This class cannot instantiate directly')
        }
    }    
    static get instance () 
    {
        if (!this[projectSingletonToken])
        {
            this[projectSingletonToken] = new Project(projectSingletonToken);
        }

        return this[projectSingletonToken];
    }
    
    get curFragmentID ()
    {
        return this._curFragmentID;
    }
    set curFragmentID (fragmentID)
    {
        this._curFragmentID = fragmentID;
    }

    get data ()
    {
        return this._data; 
        //return Object.keys(this._data).map(fragmentID => this._data[fragmentID].products); 
    }
    get products ()
    {
        return Object.keys(this._data).map(fragmentID => this._data[fragmentID].products); 
    }
    get fragments ()
    {
        const fragments = {};

        //console.log(this._fragments);

        this._fragments.forEach((fragment, i) => 
        {
            if (typeof fragment != 'undefined')
            {
                fragments[i+1] = {
                    id: i+1,
                    name: fragment
                };
            }            
        });

        return fragments;
    } 
    get structure ()
    {
        const structure = {},
            fragments = this.fragments;

        //console.log(this._data, fragments);

        Object.keys(fragments).forEach(fragmentID => 
        {
            //console.log(fragmentID);
            
            const fragment = fragments[fragmentID],
                fragmentProducts = Object.values(this._data[fragmentID].products),
                trayItems = fragmentProducts.filter(product => ['tray', 'tray_cover'].indexOf(product.type) >= 0),
                accessoryItems = fragmentProducts.filter(product => ['accessory', 'accessory_cover'].indexOf(product.type) >= 0),
                connectorItems = fragmentProducts.filter(product => ['tray_connector', 'accessory_connector'].indexOf(product.type) >= 0),
                metaeItems = fragmentProducts.filter(product => ['tray_metae', 'accessory_metae'].indexOf(product.type) >= 0),                
                shoreItems = fragmentProducts.filter(product => product.type.indexOf('shore') >= 0);

            shoreItems.sort((product1, product2) => 
            {                       
                // all metae lower down 
                const isProd1Metae = metaeProductGroups.indexOf(product1.data.group) >= 0,
                    isProd2Metae = metaeProductGroups.indexOf(product2.data.group) >= 0;

                return (isProd1Metae ^ isProd2Metae) ? (isProd1Metae - isProd2Metae) : 0;
            });
            
            structure[fragmentID] = {
                name: fragment.name,
                groups: {}
            };

            if (trayItems.length) structure[fragmentID].groups['Лоток'] = trayItems;
            if (accessoryItems.length) structure[fragmentID].groups['Аксессуары'] = accessoryItems;
            if (connectorItems.length) structure[fragmentID].groups['Соединители'] = connectorItems;
            if (metaeItems.length) structure[fragmentID].groups['Метизы'] = metaeItems;
            if (shoreItems.length) structure[fragmentID].groups['Подвесы'] = shoreItems;

            if (helper.isNotObjectOrEmpty(structure[fragmentID].groups)) delete structure[fragmentID];
        });

        //console.log(structure);

        return structure;
    }   

    init (data = null) 
    {        
        //console.log(data);

        if (!helper.isNotObjectOrEmpty(data))
        {
            this._data = data;  

            Object.keys(this._data).forEach(fragmentID => 
            {
                this._fragments[fragmentID-1] = `Фрагмент №${fragmentID}`;
            });
        }
        else
        {
            this._data = {};
            this._fragments = [];

            this.addFragment(); 
        }            
    }
    getHash (fragmentID = false)
    {
        return helper.getHashCode(this.getKey(fragmentID));
    }
    getKey (fragmentID = false)
    {
        let fragmentIDs = Object.keys(this._data),
            key = '';

        if (fragmentID && this.hasFragment(fragmentID)) fragmentIDs = [fragmentID];

        if (1 == fragmentIDs.length)
        {
            fragmentID = fragmentIDs.pop();
            const fragmentProducts = this._data[fragmentID].products;

            key = `${fragmentID}`+(!helper.isNotObjectOrEmpty(fragmentProducts)
                        ? Object.keys(fragmentProducts).reduce((res = '', productID) => 
                        {
                            const product = fragmentProducts[productID];
                            return `${res}${productID}${product.quantity}`;
                        }, '')
                        : '');
        }
        else
            key = fragmentIDs.reduce((res = '', fragmentID) => 
            {
                const fragmentProducts = this._data[fragmentID].products;
                return `${res}${fragmentID}`+(!helper.isNotObjectOrEmpty(fragmentProducts)
                            ? Object.keys(fragmentProducts).reduce((res = '', productID) => 
                            {
                                const product = fragmentProducts[productID];
                                return `${res}${productID}${product.quantity}`;
                            }, '')
                            : '');
            }, '');

        return `project${key}`;
    }
       
    addFragment () 
    {
        const fragmentID = this._fragments.push(`Фрагмент №${this._fragments.length + 1}`);
        this._data[fragmentID] = {
            products: {},
            configurator: {},
            attrs: {
                has_changed: false,
                proj_change_warn_showed: false,
                tray_change_warn_showed: false
            } 
        };
        return fragmentID;
    }
    hasFragment (fragmentID)
    {
        return fragmentID && typeof this._fragments[fragmentID-1] != 'undefined';
        //this._fragments.indexOf(fragmentID-1) >= 0 && 
    }
    delFragment (fragmentID)
    {
        if (this.hasFragment(fragmentID))
        {
            delete this._fragments[fragmentID-1];
            delete this._data[fragmentID];
        }        
    }
    getFragment (fragmentID)
    {
        const fragments = this.fragments;

        return fragmentID in fragments ? fragments[fragmentID] : null;
    }

    getFragmentAttr (fragmentID, attrName)
    {
        return this._data?.[fragmentID]?.attrs?.[attrName]; 
    }
    setFragmentAttr (fragmentID, attrName, attrValue)
    {
        //console.log('setFragmentAttr', fragmentID, attrName, attrValue, this._data);

        if (this._data?.[fragmentID] && attrName in this._data[fragmentID].attrs)
        {
            this._data[fragmentID].attrs[attrName] = attrValue;
        }
    }    
    getFragmentProducts (fragmentID)
    {
        //console.log('getFragmentProducts', fragmentID, this._data, this._data[fragmentID], this._data[fragmentID].products);
        return this.hasFragment(fragmentID) ? this._data[fragmentID].products : null;
    }
    setFragmentProducts (fragmentID, products)
    {
        //console.log('setProducts', fragmentID, products);

        if (this.hasFragment(fragmentID))
        {
            this._data[fragmentID].products = products;
        }
    }
    getFragmentConfState (fragmentID)
    {
        return this.hasFragment(fragmentID) ? this._data[fragmentID].configurator : null;
    }

    addAccessory4Tray (fragmentID, trayID, accessoryItems) 
    {
        let added = false;

        // console.log('addAccessory4Tray', fragmentID, accessoryItems);

        if (fragmentID in this._data && !helper.isNotObjectOrEmpty(accessoryItems))
        {
            const products = this._data[fragmentID].products,
                accTray = Object.values(products).find(product =>
                {
                    return 'tray' == product.type && trayID == product.data.id;
                });

            if (accTray)    
            {
                const trayCode = accTray.code,
                    accessoryCode = `accessory${accessoryItems.accessory.id}`;

                if ('quantity' in accessoryItems.accessory && accessoryItems.accessory.quantity)
                {   
                    if (accessoryCode in products) // remove prev accessory
                    {
                        ['cover', 'connector'].forEach((itemType) =>
                        {
                            if (!helper.isNotObjectOrEmpty(accessoryItems[itemType]))
                            {
                                const childProducts = 'products' in accessoryItems[itemType] ? accessoryItems[itemType].products : [accessoryItems[itemType]];

                                childProducts.forEach(product => 
                                {
                                    if (!helper.isNotObjectOrEmpty(product))
                                    {
                                        let productType = `accessory_${itemType}`;
                                        if ('connector' == itemType)
                                        {
                                            productType = metaeProductGroups.indexOf(product.group) >= 0 ? 'accessory_metae' : 'accessory_connector';
                                        }
                                        
                                        const productCode = `${productType}${product.id}`;
                                        const childK = products[trayCode].children.indexOf(productCode);
                                        if (childK >= 0)
                                        {
                                            products[trayCode].children.splice(childK, 1);
                                        }
                                        
                                        if (productCode in products)
                                        {
                                            delete products[productCode];
                                        }
                                    }
                                });
                            }                                        
                        });
                    }                    
                    products[accessoryCode] = {
                        code: accessoryCode,
                        type: 'accessory',
                        quantity: accessoryItems.accessory.quantity,
                        data: accessoryItems.accessory,
                        for_tray: trayCode,
                        children: []
                    }; 
                    if (products[trayCode].children.indexOf(accessoryCode) < 0)
                    {
                        products[trayCode].children.push(accessoryCode);
                    }
                    ['cover', 'connector'].forEach((itemType) =>
                    {
                        if (!helper.isNotObjectOrEmpty(accessoryItems[itemType]))
                        {
                            const childProducts = 'products' in accessoryItems[itemType] ? accessoryItems[itemType].products : [accessoryItems[itemType]];

                            childProducts.forEach(product => 
                            {
                                if (!helper.isNotObjectOrEmpty(product))
                                {
                                    let productType = `accessory_${itemType}`;

                                    if ('connector' == itemType)
                                    {
                                        productType = metaeProductGroups.indexOf(product.group) >= 0 ? 'accessory_metae' : 'accessory_connector';
                                    }
                                    
                                    const productCode = `${productType}${product.id}`;

                                    products[accessoryCode].children.push(productCode);
                                    products[trayCode].children.push(productCode);
                                    
                                    if ('quantity' in product && product.quantity)
                                    {
                                        if (productCode in products)
                                        {
                                            products[productCode].quantity += product.quantity;
                                        }
                                        else
                                            products[productCode] = {
                                                code: productCode,
                                                type: productType,
                                                quantity: product.quantity,
                                                data: product,
                                                for_tray: trayCode,
                                                children: []
                                            };
                                    }
                                }
                            });
                        }                                        
                    });
                    added = true;
                }
            }
        }
        //console.log('addAccessory4Tray after', this._data);
        return added;
    }  
    setFragmentProductsByConfigurator (confState)
    {
        const fragmentID = confState.fragment;

        if (this.hasFragment(fragmentID))
        {
            const confItems = helper.copyObject(confState),
                products = {};

            //console.log('setFragmentProductsByConfigurator', confItems);

            delete confItems.products_lists_by; 
            delete confItems.show_info_4product;          
            delete confItems.tray_filter; 
            delete confItems.type; 
            delete confItems.tray_type;
            delete confItems.shore_filter;
            delete confItems.tray_length;

            if ('tray' in confItems && !helper.isNotObjectOrEmpty(confItems['tray']))
            {
                const trayCode = `tray${confItems['tray'].id}`,
                    trayQuantity = confItems['tray'].quantity;
                if ('quantity' in confItems['tray'] && trayQuantity)
                {
                    products[trayCode] = {
                        code: trayCode,
                        type: 'tray',
                        quantity: trayQuantity,
                        data: confItems['tray'],
                        children: []
                    };
                    ['tray_cover', 'tray_connector'].forEach((itemType) =>
                    {
                        if (!helper.isNotObjectOrEmpty(confItems[itemType]))
                        {
                            const childProducts = 'products' in confItems[itemType] ? confItems[itemType].products : [confItems[itemType]];

                            childProducts.forEach(product => 
                            {
                                if (!helper.isNotObjectOrEmpty(product))
                                {
                                    let productType = itemType;
                                    
                                    if ('tray_connector' == itemType)
                                    {
                                        productType = metaeProductGroups.indexOf(product.group) >= 0 ? 'tray_metae' : 'tray_connector';
                                    }
                                    
                                    const productCode = `${productType}${product.id}`;

                                    // product.quantity = product.count * (this.props.tray_quantity - 1);  @todo tray_connector

                                    if ('quantity' in product && product.quantity)
                                    {
                                        products[trayCode].children.push(productCode);
                                        products[productCode] = {
                                            code: productCode,
                                            type: productType,
                                            quantity: product.quantity,
                                            data: product,
                                            children: []
                                        };
                                    }
                                }                            
                            });      
                        }                                        
                    });

                    // accessories couldn`t set from configurator after added 
                    //console.log(this._data[fragmentID]);
                    Object.values(this._data[fragmentID].products)
                            .filter(product => ['accessory', 'accessory_cover', 'accessory_connector', 'accessory_metae'].indexOf(product.type) >= 0 
                                                && ('for_tray' in product) 
                                                && trayCode == product.for_tray)
                            .forEach(product => products[product.code] = product);
                    
                    //console.log('confItems before shore_shelf ', confItems);

                    if ('shore_shelf' in confItems && !helper.isNotObjectOrEmpty(confItems['shore_shelf']))
                    {
                        const shoreCode = `shore_shelf${confItems['shore_shelf'].id}`;
                        if ('quantity' in confItems['shore_shelf'] && confItems['shore_shelf'].quantity)
                        {
                            products[shoreCode] = {
                                code: shoreCode,
                                type: 'shore_shelf',
                                quantity: confItems['shore_shelf'].quantity,
                                data: confItems['shore_shelf'],
                                children: []
                            };
                            products[trayCode].children.push(shoreCode);
                            ['shore_stud', 'shore_stud_conns', 'shore_stud_add', 'shore_stud_add_conns', 'shore_shelf_conns', 'shore_stud_shelf_conns', 'shore_connector'].forEach((itemType) =>
                            {
                                if (!helper.isNotObjectOrEmpty(confItems[itemType]))
                                {
                                    const childProducts = 'products' in confItems[itemType] ? confItems[itemType].products : [confItems[itemType]];
            
                                    childProducts.forEach(product => 
                                    {
                                        if (!helper.isNotObjectOrEmpty(product))
                                        {
                                            const productCode = `${itemType}${product.id}`;                                
                
                                            products[shoreCode].children.push(productCode);
                                            products[trayCode].children.push(productCode);
                                            
                                            if ('quantity' in product && product.quantity)
                                            {
                                                products[productCode] = {
                                                    code: productCode,
                                                    type: itemType,
                                                    quantity: product.quantity,
                                                    data: product,
                                                    children: []
                                                };
                                            }
                                        }
                                    });
                                }                                        
                            });
                        }
                    } 
                    //console.log(products);
                }
            }  
            //this._data[fragmentID] = products;
            this._data[fragmentID].products = products;
            this._data[fragmentID].configurator = confState;

            //console.log('setFragmentProductsByConfigurator', this._data[fragmentID]);
        }
    }
}
export class ModalHelper
{
    _manager = null;

    constructor (manager)
    {
        this._manager = manager;
    }
    showAlert (msg = '', onClose = null)
    {
        if (typeof onClose == 'function') onClose = () => this._manager.setState({alert_message: ''});

        this?._manager?.setState(
        {
            alert_message: msg,
            on_close: onClose
        });
    }
    showConfirm (msg = '', onClose = null, onOk = null, onCancel = null)
    {        
        if (typeof onOk != 'function') onOk = () => {};
        if (typeof onCancel != 'function') onCancel = () => this._manager.setState({alert_message: ''});
        if (typeof onClose != 'function') onClose = onCancel;

        this?._manager?.setState(
        {
            confirm_message: msg,
            on_close: onClose,
            on_ok: onOk,
            on_cancel: onCancel
        });
    }
    showProjectChangeWarning (onClose = null)
    {        
        let showed = false;
        const project = Project.instance,
            fragmentID = project.curFragmentID;
        
        if (
            true === project.getFragmentAttr(fragmentID, 'has_changed') 
            && false === project.getFragmentAttr(fragmentID, 'proj_change_warn_showed')
        )
        {
            this.showAlert('Внимание! При редактировании фрагмента в конфигураторе, изменения, внесенные во вкладке "Проект" в состав и количество элементов, не будут сохранены.', onClose);
            
            project.setFragmentAttr(fragmentID, 'proj_change_warn_showed', true);
            Store.instance.set('project', project.data);

            showed = true;
        }

        return showed;
    }
    showTrayChangeWarning (onClose = null)
    {
        let showed = false;
        const project = Project.instance,
            fragmentID = project.curFragmentID;

        if (
            project.structure?.[fragmentID] 
            && false === project.getFragmentAttr(fragmentID, 'tray_change_warn_showed')  
            && ('Аксессуары' in project.structure[fragmentID].groups 
                || 'Подвесы' in project.structure[fragmentID].groups)
        )
        {
            this.showAlert('Внимание! При изменении лотка в конфигураторе все аксессуары и монтажная система будут удалены из состава проекта.', onClose);

            project.setFragmentAttr(fragmentID, 'tray_change_warn_showed', true);
            Store.instance.set('project', project.data);

            showed = true;
        }
        else
            showed = this.showProjectChangeWarning(onClose);

        return showed;  
    }
}

export function AlertModal (params)
{
    let [show, setShow] = useState(!!params.message);
    const title = 'title' in params ? params.title : 'Сообщение конфигуратора:',
        onHide = 'on_close' in params ? params.on_close : (() => setShow(false));

    show = !!params.message;

    return <Modal 
        show={show}
        onHide={onHide}
    >
        <Modal.Header closeButton>
            <Modal.Title as="div" className="h5">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {params.message}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="primary" onClick={onHide}>Закрыть</Button>
        </Modal.Footer>
    </Modal>
} 
export function ConfirmModal (params)
{
    let [show, setShow] = useState(!!params.message);
    const title = 'title' in params ? params.title : 'Конфигуратор: подтвердите действие',
        onHide = 'on_close' in params ? params.on_close : (() => setShow(false)),
        onOk = () => 'on_ok' in params ? params.on_ok() : setShow(false),
        onCancel = () => 'on_cancel' in params ? params.on_cancel() : setShow(false);

    show = !!params.message;

    return <Modal 
        show={show}
        onHide={onHide}
    >
        <Modal.Header closeButton>
            <Modal.Title as="div" className="h5">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {params.message}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="primary" onClick={onOk}>Ок</Button>
            <Button variant="secondary" onClick={onCancel}>Отменить</Button>
        </Modal.Footer>
    </Modal>
} 
export const helper =
{    
    isNotObjectOrEmpty: function (obj)
    {
        return null === obj || (typeof obj != 'object') || 0 == Object.keys(obj).length;
    },
    isArrayAndNotEmpty: function (arr)
    {
        return Array.isArray(arr) && arr.length;
    },
    copyObject: function (obj)
    {
        return !helper.isNotObjectOrEmpty(obj) ? cloneDeep(obj) : null;
    },
    unique: function (array)
    {
        return uniq(array);
    },
    toNumber: function (item)
    {
        item -= 0;
        if (isNaN(item)) item = 0;
        return item;
    },
    forEach: function (obj)
    {
        return forEach(obj);
    },
    sortNatural: function (a, b) 
    {
        a = helper.toNumber(a);
        b = helper.toNumber(b);

        if (a > b)
        {
            return 1;
        }
        else if (a < b)
        {
            return -1;
        }
        else
            return 0;
    },
    isProductsEqual: function (productA, productB)
    {
        return false;
    },
    fillItem: function (fields, product)
    {
        //console.log(fields);
        ({
            code: product.id,
            //id: product.realID,
            catNum: product.articul,
            name: product.name,
            width: product.width = 0,
            height: product.height = 0,
            length: product.length = 0,
            count: product.count = 1,
            weight: product.weight = 0,
            price: product.price = 0,
            measure: product.measure = 'шт.',
            picFile: product.pic_file,
            textFile: product.txt_file,            
            groupID: product.group
        } = fields);

        ['width', 'height', 'length', 'count', 'weight', 'price', 'group'].forEach(field => 
        {
            product[field] = helper.toNumber(product[field]);
        });
        //console.log(product);
    },
    isMeterProduct: function (product)
    {
        //console.log('isMeterProduct', product, 'measure' in product, 'length' in product, ('м' == product.measure || 'м.' == product.measure), product.length > 0);

        return 'measure' in product 
                && 'length' in product 
                && ('м' == product.measure || 'м.' == product.measure) 
                && product.length > 0;
    },
    setStateWithRecievedItems: function (component, stateField, recievedItems, fillSpecFldsCallback = null)
    {
        const items = {};

        recievedItems.forEach(function (itemFields)
        {
            const item = {};

            helper.fillItem(itemFields, item);

            if (typeof fillSpecFldsCallback == 'function')
            {
                fillSpecFldsCallback(itemFields, item);
            }
            
            items[item.id] = item;
        });

        component.setState({[stateField]: items, loading: false});

        return items;
    },
    getHashCode: function  (value)
    {
        let hash = 0, i, chr;

        for (i = 0; i < value.length; i++) 
        {
            chr   = value.charCodeAt(i);
            hash  = ((hash << 5) - hash) + chr;
            hash |= 0;
        }

        return hash;
    },
    _devtools: 
    {
        clearAppStore: function ()
        {
            Store.instance.set('project', {})
                    .then(() => 
                    {
                        return Store.instance.set('configurator', {})
                    })
                    .then(() => 
                    {
                        console.log('store is cleared, reloading...');
                        window.location.href = '/';
                    })
                    .catch(function (error)
                    {
                        console.log(error);
                    });
        }
    }
}
export const metaeProductGroups = [117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 128, 129, 130, 131, 132, 133, 137, 147];
export const ProductsListsContext = React.createContext('articul');
export class Error4Admin extends Error {}
export class Error4User extends Error {}